import { ControlType, FormFieldBase } from './form-field-base.model';

export class ChipsMultiSelectFormField extends FormFieldBase<string[]> {
  controlType: ControlType = 'chips-multi-select';
}
